import { alpha, type SxProps, type Theme } from '@mui/material';

// App bar fill: the bright brand blue in light mode, and a deeper brand blue in
// dark mode so the bar keeps its identity without glaring over dark surfaces.
export const getHeaderBackground = (theme: Theme) =>
  theme.palette.mode === 'dark'
    ? theme.palette.primary.dark
    : theme.palette.primary.main;

// Focus ring for controls on the app bar. The theme's default ring is brand
// blue, which disappears against the blue header, so use white instead.
export const headerFocusRing = (theme: Theme) => ({
  outline: `2px solid ${alpha(theme.palette.common.white, 0.85)}`,
  outlineOffset: 2,
});

// Shared square icon button for the app bar (navigation, uploads, theme) so
// every header action has the same size, shape, border and hover state.
export const headerActionSx: SxProps<Theme> = (theme) => ({
  width: 36,
  height: 36,
  p: 0,
  flexShrink: 0,
  borderRadius: '8px',
  color: theme.palette.common.white,
  bgcolor: 'transparent',
  border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
  transition: theme.transitions.create(['background-color', 'border-color'], {
    duration: theme.transitions.duration.shortest,
  }),
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
  '&:hover': {
    bgcolor: alpha(theme.palette.common.white, 0.12),
    borderColor: alpha(theme.palette.common.white, 0.32),
  },
  '&:focus-visible': headerFocusRing(theme),
});
